import DashboardLayout from "../../layouts/DashboardLayout";
import React, { useState, useEffect } from "react";
import "./AddProductPage.css";
import {
  PRODUCT_DELETE_URL,
  PRODUCT_IMAGE_URL,
  PRODUCT_LIST_URL,
  PRODUCT_DETAILS_URL
} from "../../utils/Constant";
import loginUser from "../../utils/authService";
import axios from "axios";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { convertIsoToCustomFormat, convertIsoToLocalFormat, formatDate } from "../../utils/Helper";

const ProductListPage = () => {
  const [productData, setProductData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [productIdToDelete, setProductIdToDelete] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isBidDeleted, setIsBidDeleted] = useState(false);
  const [currentOrderItem, setCurrentOrderItem] = useState(null);
  const [filter, setFilter] = useState("All");
  const [selectedProducts, setSelectedProducts] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [isRelistModalOpen, setIsRelistModalOpen] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [relistLoading, setRelistLoading] = useState(false);
  const [relistSuccess, setRelistSuccess] = useState(false);

  const navigate = useNavigate();
  const authToken = useSelector((state) => state.token);

  async function fetchProducts(selectedFilter = filter) {
    setLoading(true);
    try {
      const response = await fetch(`${PRODUCT_LIST_URL}?filter=${selectedFilter}`, {
        headers: {
          Authorization: `Bearer ${authToken.token}`,
        },
        credentials: "include",
      });
      const json = await response.json();
      setLoading(false);
      setProductData(json.data);
      setSelectedProducts([]);
      setSelectAll(false);
      console.log("json.data", json.data);
    } catch (err) {
      //console.log("err", err);
    }
  }

  useEffect(() => {
    if (authToken) {
      fetchProducts(filter);
    } else {
      navigate("/login");
    }
  }, [authToken, filter]);

  const handleConfirmDelete = async () => {
    try {
      await axios
        .delete(`${PRODUCT_DELETE_URL}/${productIdToDelete}`, {
          headers: {
            Authorization: `Bearer ${authToken.token}`,
          },
        })
        .then((response) => {
          // Check the status code to determine if the deletion was successful
          if (response.status === 200) {
            setIsBidDeleted(true);
            setTimeout(() => {
              setIsBidDeleted(false);
              handleCloseModal();
              fetchProducts();
            }, 1000);
          } else {
            console.error("Deletion failed. Status code:", response.status);
          }
        })
        .catch((error) => {
          console.error("Error deleting product:", error);
        });
    } catch (error) {
      console.error("Error deleting product:", error);
      // Handle other errors if needed
    }
  };
  const Modal = ({ isOpen, onClose, onDelete }) => {
    return (
      <div className={`modal1 ${isOpen ? "open" : ""}`}>
        <div className="modal1-overlay" onClick={onClose}></div>
        <div className="modal1-content">
          {!isBidDeleted ? (
            <>
              <p>Product Name : {currentOrderItem?.productName}</p>
              <p>Are you sure you want to delete?</p>

              <div className="button-container">
                <button className="cancel-button" onClick={onClose}>
                  Cancel
                </button>
                <button className="delete-button" onClick={onDelete}>
                  Delete
                </button>
              </div>
            </>
          ) : (
            <div class="alert alert-success" role="alert">
              Product Deleted Successfully!
            </div>
          )}
        </div>
      </div>
    );
  };

  const handleDelete = (order) => {
    //console.log("first", order._id);
    setProductIdToDelete(order._id);
    setCurrentOrderItem(order);
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setProductIdToDelete(null);
    setCurrentOrderItem(null);
    setIsModalOpen(false);
  };

  const RelistModal = ({
    isOpen,
    onClose,
    onRelist,
    startDate,
    endDate,
    setStartDate,
    setEndDate,
    loading,
    success
  }) => {
    return (
      <div className={`modal1 ${isOpen ? "open" : ""}`}>
        <div className="modal1-overlay" onClick={onClose}></div>
        <div className="modal1-content">
          <h5>Relist Selected Products</h5>
          <div className="row">
            <div className="col-6">
              <div className="form-group">
                <label htmlFor="startDate">Start Date</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  id="startDate"
                  name="startDate"
                  value={startDate}
                  onChange={(e) => setStartDate(e.target.value)}
                />
              </div>
            </div>
            <div className="col-6">
              <div className="form-group">
                <label htmlFor="endDate">Ending Date</label>
                <input
                  type="datetime-local"
                  className="form-control"
                  id="endDate"
                  name="endDate"
                  min={startDate}
                  value={endDate}
                  onChange={(e) => setEndDate(e.target.value)}
                />
              </div>
            </div>
          </div>
          <div className="button-container" style={{ marginTop: "20px" }}>
            <button className="cancel-button" onClick={onClose}>
              Cancel
            </button>
            <button
              className="btn btn-primary"
              onClick={onRelist}
              disabled={loading || !startDate || !endDate}
              style={{ marginLeft: "10px" }}
            >
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
          {success && (
            <div className="alert alert-success mt-3" role="alert">
              Bid dates updated successfully!
            </div>
          )}
        </div>
      </div>
    );
  };

  const handleRelist = async () => {
    setRelistLoading(true);
    setRelistSuccess(false);
    try {
      const productsPayload = selectedProducts.map((id) => ({
        productId: id,
        bidStartDate: startDate,
        bidEndDate: endDate,
      }));

      await axios.post(`${PRODUCT_DETAILS_URL}/update/biddates`,
        { products: productsPayload },
        {
          headers: {
            Authorization: `Bearer ${authToken.token}`,
            "Content-Type": "application/json",
          },
        }
      );
      setRelistLoading(false);
      setRelistSuccess(true);
      setTimeout(() => {
        setIsRelistModalOpen(false);
        setRelistSuccess(false);
        fetchProducts(filter);
      }, 1200);
    } catch (err) {
      setRelistLoading(false);
      alert("Failed to update bid dates.");
    }
  };

  return (
    <DashboardLayout dashboard="Products">
      <div style={{ marginTop: "10px" }}>
            <button
              className={`btn btn-outline-primary btn-sm ${filter === "All" ? "active" : ""}`}
              onClick={() => { setFilter("All"); fetchProducts("All"); }}
            >
              All
            </button>
            <button
              className={`btn btn-outline-warning btn-sm ${filter === "expired" ? "active" : ""}`}
              style={{ marginLeft: "5px" }}
              onClick={() => { setFilter("expired"); fetchProducts("expired"); }}
            >
              Expired
            </button>
            <button
              className={`btn btn-outline-danger btn-sm ${filter === "expiredWith0Bids" ? "active" : ""}`}
              style={{ marginLeft: "5px" }}
              onClick={() => { setFilter("expiredWith0Bids"); fetchProducts("expiredWith0Bids"); }}
            >
              Expired With 0 Bids
            </button>
          </div>
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Auction Products</h3>
          <div className="card-tools">
            <a className="btn btn-primary btn-sm" href="/products/create">
              <i className="fas fa-plus"> </i>
              Add New Product
            </a>
            <button
              className="btn btn-success btn-sm"
              style={{ marginLeft: "10px" }}
              disabled={selectedProducts.length === 0}
              onClick={() => setIsRelistModalOpen(true)}
            >
              <i className="fas fa-redo"></i> Relist Selected
            </button>
          </div>
          
        </div>
        <div className="card-body table-responsive p-0">
          <table className="table table-striped projects">
<thead>
  <tr>
    <th style={{ width: "3%" }}>
      <input
        type="checkbox"
        checked={selectAll}
        onChange={(e) => {
          setSelectAll(e.target.checked);
          if (e.target.checked) {
            setSelectedProducts(productData.map((product) => product._id));
          } else {
            setSelectedProducts([]);
          }
        }}
      />
    </th>
    <th style={{ width: "3%" }}>#</th>
    <th style={{ width: "5%" }}>Image</th>
    <th style={{ width: "10%" }}>Name</th>
    <th style={{ width: "10%" }}>Stock(Quantity)</th>
    <th style={{ width: "10%" }}>Auction Status</th>
    <th style={{ width: "10%" }}>Category</th>
    <th style={{ width: "10%" }}>Live Status</th>
    <th style={{ width: "8%" }}>Visibility</th>
    <th style={{ width: "8%" }}>Opening Price</th>
    <th style={{ width: "8%" }}>Bid Won</th>
    <th style={{ width: "8%" }}>Relisted</th>
    <th style={{ width: "10%" }} className="text-center">
      Actions
    </th>
  </tr>
</thead>
<tbody>
  {loading && (
    <tr>
      <td className="text-center" colSpan="15">
        <div className="text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </div>
      </td>
    </tr>
  )}

  {!loading &&
    productData.map((product, index) => {
      const canSelect =
        product.isBidWon === false &&
        product.isOrdered === false;

      return (
        <tr key={index}>
          <td>
            {canSelect ? (
              <input
                type="checkbox"
                checked={selectedProducts.includes(product._id)}
                onChange={(e) => {
                  if (e.target.checked) {
                    setSelectedProducts([...selectedProducts, product._id]);
                  } else {
                    setSelectedProducts(selectedProducts.filter(id => id !== product._id));
                    setSelectAll(false);
                  }
                }}
              />
            ) : null}
          </td>
          <td>{index + 1}</td>
          <td>
            <ul className="list-inline">
              <li className="list-inline-item">
                <img
                  alt=""
                  className="table-avatar"
                  src={`${PRODUCT_IMAGE_URL}/${product.featuredImage}`}
                />
              </li>
            </ul>
          </td>
          <td>
            <a
              href={`https://www.mototrad.com/products/${product._id}`}
              target="_blank"
              style={{ textDecoration: "none" }}
            >
              {product.productName}
            </a>
            <br />
            <small>
              Created {convertIsoToCustomFormat(product.createdAt)}
            </small>
          </td>
          <td className="project-state">
            <span
              className={`custom-badge ${
                product.inStock
                  ? "custom-badge-success"
                  : "custom-badge-danger"
              }`}
            >
              {product.inStock
                ? `In Stock(${product.quantity})`
                : `Out of Stock(${product.quantity})`}
            </span>
          </td>
          <td className="project-state">
            <span
              className={`custom-badge ${
                new Date(product.bidEndDate) > new Date()
                  ? "custom-badge-success"
                  : "custom-badge-danger"
              }`}
            >
              {new Date(product.bidEndDate) > new Date()
                ? `Auction Live`
                : `Auction Expired`}
              <br />
              <small>
                {product.bidsDetails
                  ? product.bidsDetails.length + " Bid"
                  : "No Bid"}
              </small>
            </span>
          </td>
          <td>
            {product.categoryId
              ? product.categoryId.categoryName
              : "N/A"}
          </td>
          <td className="project-state">
            <span
              className={`badge ${
                product.isLive ? "badge-success" : "badge-danger"
              }`}
            >
              {product.isLive ? `Live` : `Not Live`}
            </span>
          </td>
          <td className="project-state">
            <span
              className={`badge ${
                product.productStatus === "publish"
                  ? "badge-success"
                  : product.productStatus === "draft"
                  ? "badge-info"
                  : "badge-warning"
              }`}
            >
              {product.productStatus}
            </span>
          </td>
          {/* Opening Price */}
          <td>
            <span className="">
              ${product.openingPrice}
            </span>
          </td>
          {/* isBidWon */}
          <td>
            <span
              className={`badge ${
                product.isBidWon
                  ? "badge-success"
                  : "badge-danger"
              }`}
            >
              {product.isBidWon ? "Won" : "Not Won"}
            </span>
          </td>
          {/* isRelisted */}
          <td>
            <span
              className={`badge ${
                product.isRelisted
                  ? "badge-warning"
                  : "badge-secondary"
              }`}
            >
              {product.isRelisted ? "Relisted" : "Not Relisted"}
            </span>
          </td>
          <td className="project-actions text-right">
            <a
              className="btn btn-info btn-sm"
              href={`/products/update/${product._id}`}
            >
              <i className="fas fa-pencil-alt"> </i>
            </a>
            <>
              <a
                className="btn btn-danger btn-sm"
                onClick={() => handleDelete(product)}
              >
                <i className="fas fa-trash"> </i>
              </a>
              <Modal
                isOpen={isModalOpen}
                onClose={handleCloseModal}
                onDelete={handleConfirmDelete}
              />
            </>
          </td>
        </tr>
      );
    })}
</tbody>

          </table>
        </div>
        {/* /.card-body */}
      </div>
      <RelistModal
        isOpen={isRelistModalOpen}
        onClose={() => setIsRelistModalOpen(false)}
        onRelist={handleRelist}
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
        loading={relistLoading}
        success={relistSuccess}
      />
    </DashboardLayout>
  );
};

export default ProductListPage;
